export const CCI_ACCOUNT_TYPE_CODES = ['LP_CCI', 'LP_CCI_ALT'] as const;

export const VIRTUAL_ACCOUNT_TYPE_CODES = ['V_VISTA', 'V_ELECTRONIC'] as const;

/**
 * Tipos de cuenta deprecados y su reemplazo soportado.
 * Agregar aquí nuevos pares legacy → sucesor; el util aplica la regla en todo el front.
 */
export const DEPRECATED_BANK_ACCOUNT_REPLACEMENTS = {
  LP_CCI: 'LP_CCI_ALT',
} as const satisfies Record<string, string>;
